module.exports = __webpack_public_path__ + "img/jonas.3bee6a7b.jpg";